import React from 'react'

import { SortDrawer } from 'components/UI/SortDrawer'
import type { SortOption, SortEntry, SortDrawerProps } from 'components/UI/SortDrawer'

/**
 * Provenance sort — the field list, and nothing else.
 *
 * The sheet itself is `components/UI/SortDrawer`. This file used to carry its own
 * ~159-line copy of it; the copies differed only in this list.
 *
 * Types declared here for the first time. `date` was offering "A - Z" / "Z - A",
 * and `sell_price` — a CURRENCY — was too; it now reads "Low - High".
 */
export type ProvenanceSortField = 'owner_name' | 'date' | 'sell_price'
export type ProvenanceSortDirection = 'ASC' | 'DESC'
export type AdditionalProvenanceSort = SortEntry<ProvenanceSortField>

const OPTIONS: SortOption<ProvenanceSortField>[] = [
  { key: 'owner_name', label: 'Owner name', type: 'string' },
  { key: 'date', label: 'Date', type: 'dateTime' },
  { key: 'sell_price', label: 'Sell price', type: 'number' },
]

export type ProvenanceSortDrawerProps = Omit<SortDrawerProps<ProvenanceSortField>, 'options'>

export const ProvenanceSortDrawer: React.FC<ProvenanceSortDrawerProps> = props => (
  <SortDrawer<ProvenanceSortField> {...props} options={OPTIONS} />
)

export default ProvenanceSortDrawer
